<template>
    <div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    created(){
      let userKey = this.$route.query.userKey
      if(userKey){
        this.$http.get('/api/ts/v0.1/common/myTestSso',{params:{userKey}})
        .then(res=>{
          localStorage.setItem('tsUserGuid',res.data.uGuid)
          localStorage.setItem('oguGuid',res.data.orgUserGuid)
          localStorage.setItem('tsToken',res.data.token)
          this.Cookie.set('tsUserGuid',res.data.uGuid)
          this.Cookie.set('oguGuid',res.data.orgUserGuid)
          this.Cookie.set('oguName',res.data.uName)
        })
        return
      }
      this.$http.get('/api/ts/v0.1/common/tdSsoVer',{params:{
        fdId:this.$route.query.fdId,
        encryData:this.$route.query.encryData,
        tag:this.$route.query.tag
      }})
      .then(res=>{
        if(res.data.message){
          this.Toast.fail(res.data.message);
          return
        }
        localStorage.setItem('tsUserGuid',res.data.uGuid)
        localStorage.setItem('oguGuid',res.data.orgUserGuid)
        localStorage.setItem('tsToken',res.data.token)
        this.Cookie.set('tsUserGuid',res.data.uGuid)
        this.Cookie.set('oguGuid',res.data.orgUserGuid)
        this.Cookie.set('oguName',res.data.uName)
        let page = res.data.toPage
        if(page){
          if(page.startsWith('http')){
            window.location.href = page
          }else{
            window.location.href = window.location.origin+page
          }
        }
      }).catch(res=>{
        this.Toast.fail(res.response.data.message);
      })
    }
}
</script>
<style scoped lang="less">
</style>